import React, { Suspense, lazy } from "react";
import { shallowEqual, useSelector } from "react-redux";
import AuthInit from "modules/auth/AuthInit";
import GlobalLoader from "components/shared/globalLoader/GlobalLoader";
import axios from "./utils/interceptors";
const AuthRoutes = lazy(() => import("./AuthRoutes"));
const NonAuthRoutes = lazy(() => import("./NonAuthRoutes"));

function App() {
  const { isAuthorized, token } = useSelector((state) => state.auth, shallowEqual);
  return (
    <AuthInit>
      <Suspense fallback={<GlobalLoader />}>{isAuthorized && token ? <AuthRoutes /> : <NonAuthRoutes />}</Suspense>
    </AuthInit>
  );
}
export default App;
